import type { DocTypeRepository } from "../repositories/doc-type-repository"

export const makeListDocTypes = (repo: DocTypeRepository) => () => repo.list()
